<template>
  <TImageInfo
    class="mt-4"
    :title="item.name"
    :subtitle="item.village.name + ', ' + item.province.name"
    :image="imgUrl"
    :stars="item.review.averageReviews"
  ></TImageInfo>

  <TGrid class="mt-4">
    <div class="col-span-6 lg:col-span-5">
      <TText classes="m-0" size="sm" variant="semibold">{{
        $t('views.cottage-contact-deal.info.dateIn')
      }}</TText>
      <TText> {{ item.deal.dateIn }} </TText>
    </div>
    <div class="col-span-6 lg:col-span-5">
      <TText classes="m-0" size="sm" variant="semibold">{{
        $t('views.cottage-contact-deal.info.dateOut')
      }}</TText>
      <TText> {{ item.deal.dateOut }} </TText>
    </div>
    <div class="col-span-6 lg:col-span-5">
      <TText classes="m-0" size="sm" variant="semibold">{{
        $t('views.cottage-contact-deal.info.nights')
      }}</TText>
      <TText>
        {{ item.deal.nights }}
      </TText>
    </div>
    <div class="col-span-6 lg:col-span-5">
      <TText classes="m-0" size="sm" variant="semibold">{{
        $t('views.cottage-contact-deal.info.people')
      }}</TText>
      <TText>
        {{ item.deal.people }}
      </TText>
    </div>

    <div
      v-if="item.deal.whatIncludes && item.deal.whatIncludes.length > 0"
      class="col-span-12"
    >
      <TText classes="m-0" size="sm" variant="semibold">{{
        $t('views.cottage-contact-deal.info.whatIncludes')
      }}</TText>
      <TText>
        <span v-html="item.deal.whatIncludes" />
      </TText>
    </div>
  </TGrid>
</template>

<script setup lang="ts">
import type { CottageContactDealPage } from '~/modules/views/cottage-contact-deal/entities/CottageContactDealPage'

interface propsInterface {
  item: CottageContactDealPage
}

const props = defineProps<propsInterface>()

const imgUrl =
  props.item.media
    .filter(item => {
      return item.type === 'PHOTO'
    })
    .at(0)?.url || ''
</script>
